import type { ChangeEvent } from "react";
import "./EditNote.scss";

type Props = {
  value?: string;
  noteOnChange: (note: string) => void;
  maxLength?: number;
  show?: boolean;
};

const EditNote = ({ noteOnChange, value, maxLength = 1000, show = true }: Props) => {
  const _noteOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    const note = e.target.value;
    noteOnChange(note);
  };

  if (show === true) {
    return (
      <div className="edit-note">
        <textarea
          className="edit-note__text-area"
          aria-label="Edit note"
          rows={8}
          maxLength={maxLength}
          value={value ?? ""}
          onChange={_noteOnChange}
        />
        <div className="edit-note__counter">
          {value?.length || 0}/{maxLength}
        </div>
      </div>
    );
  }

  return <></>;
};

export default EditNote;
